import { FunctionComponent } from 'react';
import { faSquareList } from '@fortawesome/duotone-light-svg-icons';
import { ConfigurationType, IConfigurationForm, LinkedProperties } from '@/utilities/forms/ConfigurationFormProcessor';
import ConfigurationItem, { IConfigurationExpandProps } from './ConfigurationItem';

const ConfigurationFormForm: FunctionComponent<IConfigurationForm & IConfigurationExpandProps> = ({ setExpanded, toggleExpand, expanded, ...item}) => {
    const {
        trialConfiguration,
        formPropertyPath,
        formMetadata,
        isGlobalConfiguration,
        isTrialConfiguration
    } = item;

    return (
        <ConfigurationItem
            toggleExpand={toggleExpand}
            setExpanded={setExpanded}
            expanded={expanded}
            spacing={isGlobalConfiguration ? 0 : 8}
            basePropertyPath={formPropertyPath!}
            edit
            expandable
            enableable={!isTrialConfiguration && !isGlobalConfiguration}
            linkable={!isTrialConfiguration}
            linkedProperties={LinkedProperties[ConfigurationType.Form]}
            title={formMetadata?.name ?? 'Unknown Form'}
            type="CRF"
            typeIcon={faSquareList}
            item={item}
        />
    );
}

export default ConfigurationFormForm;